module.exports = __webpack_public_path__ + "static/img/Epsilon-Selected.2800883.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Epsilon-Selected.png
// module id = 739
// module chunks = 0